import isNull from 'lodash/isNull';
export const _isNull = isNull;
